import { isDMITrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { RewardsSideBar } from "app/components/React/sideTabs/RewardsSideBar";

export const RewardsSideBarContainer = () => {
    return isDMITrial() ? <RewardsSideBar /> : null;
};
